var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterPanelIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56006 4.84798C4.56006 7.03198 4.68006 7.19998 8.04006 9.69598L10.5601 11.568V16.248V20.928L12.0001 19.512L13.4401 18.096V14.832L13.4641 11.592L15.9841 9.67198C19.3441 7.15198 19.4401 7.03198 19.4401 4.84798V3.07198H12.0001H4.56006V4.84798ZM18.0001 5.27998C18.0001 5.71198 17.9041 6.19198 17.8081 6.33598C17.4481 6.88798 12.3841 10.512 12.0001 10.512C11.6161 10.512 6.60006 6.88798 6.19206 6.31198C6.09606 6.19198 6.00006 5.71198 6.00006 5.27998V4.51198H12.0001H18.0001V5.27998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPanelIc);
export default __webpack_public_path__ + "static/media/filter_panel_ic.7420fe5c.svg";
export { ForwardRef as ReactComponent };